import { Linkedin, Twitter, Facebook, Mail, Instagram, Youtube, MapPin, Phone, MessageCircle } from "lucide-react";
import { memo } from "react";

const Footer = memo(function Footer() {
  const footerLinks = {
    Company: [
      { label: "About Us", href: "/about" },
      { label: "Director's Message", href: "/dir-mes" },
      { label: "Divisions", href: "/divisions" },
      { label: "Career", href: "/career" },
    ],
    Products: [
      { label: "All Products", href: "/prod" },
      { label: "Therapeutics", href: "/therapy" },
    ],
    Resources: [
      { label: "Blogs", href: "/blogs" },
      { label: "Contact", href: "/contact" },
    ],
  };

  const socialLinks = [
    { icon: Linkedin, href: "https://www.linkedin.com/in/benvora-bioscience-a88805395/", label: "LinkedIn" },
    { icon: Twitter, href: "https://x.com/BenvoraB", label: "Twitter" },
    { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61583547982162", label: "Facebook" },
    { icon: Instagram, href: "https://www.instagram.com/benvora_bioscience/?hl=en", label: "Instagram" },
    { icon: Youtube, href: "https://www.youtube.com/@BenvoraBioscience", label: "YouTube" },
    { icon: MessageCircle, href: "https://wa.me/917009223262", label: "WhatsApp" },
  ];

  return (
    <footer className="bg-primary text-primary-foreground border-t border-primary-foreground/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo and Contact Info */}
          <div className="col-span-1 md:col-span-2 lg:col-span-1">
             <img
              src="/assets/Screenshot_2026-01-28_153543.png"
              alt="Benvora Bioscience"
              className="h-12 md:h-14 mb-6 w-auto object-contain bg-white rounded-lg p-2 shadow-sm"
            />
                          <div className="space-y-4 text-primary-foreground text-sm">
                            <div className="flex items-start gap-3">
                              <MapPin className="h-4 w-4 mt-1 text-primary-foreground flex-shrink-0" />
                              <span>Plot No.367, Abhey Pur, Industrial Area Phase-1, Panchkula, Haryana 134109</span>
                            </div>
                            <div className="flex items-center gap-3">
                              <Phone className="h-4 w-4 text-primary-foreground flex-shrink-0" />
                              <a href="tel:+917009223262" className="hover:text-primary-foreground/80 transition-colors">+91 7009223262</a>
                            </div>
                            <div className="flex items-center gap-3">
                              <MessageCircle className="h-4 w-4 text-primary-foreground flex-shrink-0" />
                              <a href="https://wa.me/917009223262" target="_blank" rel="noopener noreferrer" className="hover:text-primary-foreground/80 transition-colors">Chat on WhatsApp</a>
                            </div>
                            <div className="flex items-center gap-3">
                              <Mail className="h-4 w-4 text-primary-foreground flex-shrink-0" />
                              <a href="mailto:info@benvorabioscience.com" className="hover:text-primary-foreground/80 transition-colors">info@benvorabioscience.com</a>
                            </div>
                          </div>
                        </div>
            
                        {/* Footer Links */}
                        {Object.entries(footerLinks).map(([category, links]) => (
                          <div key={category}>
                            <h3 className="font-semibold text-primary-foreground mb-4 text-lg">{category}</h3>
                            <ul className="space-y-3">
                              {links.map((link) => (
                                <li key={link.label}>
                                  <a href={link.href} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                                    {link.label}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
            
                      {/* Bottom Bar */}
                      <div className="pt-8 border-t border-primary-foreground/10">
                        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                          <p className="text-sm text-primary-foreground/80">
                            &copy; {new Date().getFullYear()} Benvora Bioscience. All rights reserved.
                          </p>
                          <div className="flex items-center gap-4">
                            {socialLinks.map(social => (
                              <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.label} className="text-primary-foreground hover:text-primary-foreground/80 transition-colors">
                                <social.icon className="h-5 w-5" />
                              </a>
                            ))}
                          </div>
                          <div className="flex gap-6 text-sm">
                            <a href="#" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">Privacy Policy</a>
                            <a href="#" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">Terms of Service</a>
                          </div>          </div>
        </div>
      </div>
    </footer>
  );
});

export default Footer;